// extracted by mini-css-extract-plugin
export var container = "_2r-0";